<ppl-login-common
  [value]="user$ | async"
  [mode]="mode"
  [loading]="validating$ | async"
  [error]="error$ | async"
  [errorMessage]="error_str$ | async"
  [description]="description"
  [googleShowLogin]="googleSignInVisible$ | async"
  [googleLoginDisabled]="!(googleAuth2LibraryLoaded$ | async)"
  [microsoftShowLogin]="microsoftSignInVisible$ | async"
  [signUpUrl]="signUpUrl"
  (valueChange)="onSubmit($event)"
  (edit)="onEditEmail()"
  (googleLogin)="onGoogleLogin()"
  (microsoftLogin)="onMicrosoftLogin()"></ppl-login-common>
